
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  display:block;
  overflow:hidden;

  --spacing-screen-xs:var(--spacing-03);
  --spacing-screen-md:var(--spacing-06);
  --spacing-screen-lg:var(--spacing-08);
}

.wrapper{
  display:flex;
  grid-template-rows:2;
  padding-top:var(--spacing-screen-xs);
}

@media (min-width: 768px){

.wrapper{
    padding-top:var(--spacing-screen-md)
}
  }

@media (min-width: 1024px){

.wrapper{
    padding-top:var(--spacing-screen-lg)
}
  }

.visually-hidden{
  position:absolute !important;
  overflow:hidden;
  clip:rect(1px, 1px, 1px, 1px);
  width:1px;
  height:1px;
  word-wrap:normal;
}
`;